export default __webpack_public_path__ + "static/NNNittiGrotesk-TextBold-02c5978cd3d7dc00a4b393724bd55e8e.woff";